import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager" */ "/app/src/assets/1-Inkasso.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/2-Inkasso.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/3-Inkasso.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/fourthSectionVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/inkassoBottomMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/inkassoFirstCardVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/inkassoSecondCardVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/InkassoSecondSecBottomVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/inkassoSecondSecTopVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/inkassothirdCardBottom.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/inkassothirdCardTopVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/inkassoTopRightMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Food.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/groupIcon.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkasobottom.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkasso/kristian.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkasso/nina.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkasso/pia.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkasso/vectors/adviserLeftVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkasso/vectors/adviserRightVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/InkassoLadies.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkassoMobileLedisImage .png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/InkassoPersonRightSide.webp");
;
import(/* webpackMode: "eager" */ "/app/src/assets/inkassoThirdSectionVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/linkedinProfilePic.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Testimonial-1.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Testimonial-2.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Testimonial-3.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/client/PreviewScroll.client.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/client/RedirectButton.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/client/TrustpilotWidget.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/CustomAccordion.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/MobileSlider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/section/client/TestimonialsSwiper.client.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/TrustpilotWidget.jsx");
